export default __webpack_public_path__ + "static/invimatic-iso-more-news-4-bb991273abfaa5820f4248e51b555545.png";